import Alpine from 'alpinejs';
import Swiper from 'swiper/bundle';
import focus from '@alpinejs/focus';
import AOS from 'aos';

window.Alpine = Alpine;
window.Swiper = Swiper;

document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 2,
    spaceBetween: 30,
  });
});

Alpine.data('timelineCarousel', () => ({
  init() {
    new Swiper('.timelineCarousel', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1.1,
      spaceBetween: 8,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: true,
    });
  },
}));

function smoothScroll(identifier, offset = 0) {
  const header = document.getElementById('main-header');
  let headerHeight = header?.offsetHeight ?? 0;

  const element = document.querySelector(identifier);
  if (element) {
    const clientRect = element.getBoundingClientRect();
    let elementPos = clientRect.top + window.scrollY - headerHeight - offset;
    window.scrollTo({
      top: elementPos,
      behavior: 'smooth',
    });
  }
}

window.smoothScroll = smoothScroll;

Alpine.plugin(focus);
Alpine.start();
AOS.init();
let scrollRef = 0;

window.addEventListener('scroll', function () {
  // increase value up to 10, then refresh AOS
  scrollRef++;
  if (scrollRef >= 10) {
    AOS.refresh();
    scrollRef = 0;
  }
});
// To clear cart when locale changes
window.addEventListener('DOMContentLoaded', () => {
  const clearCartLocaleBased = () => {
    let previousUrl = document.referrer;
    let prevReferrer = localStorage.getItem('prevReferrer');
    if (prevReferrer && prevReferrer == previousUrl) {
      return;
    }
    const currentUrl = window.location.href;
    localStorage.setItem('prevReferrer', previousUrl);

    const isCurrentLocaleCa = currentUrl.includes('/en-ca');
    const isCurrentLocaleAu = currentUrl.includes('/en-au');
    const isCurrentLocaleUs = !isCurrentLocaleCa && !isCurrentLocaleAu;

    const wasPreviousLocaleCa = previousUrl.includes('/en-ca');
    const wasPreviousLocaleAu = previousUrl.includes('/en-au');
    const wasPreviousLocaleUs = previousUrl === '' || (!wasPreviousLocaleCa && !wasPreviousLocaleAu);

    const localeChanged =
      (isCurrentLocaleCa && (wasPreviousLocaleUs || wasPreviousLocaleAu)) ||
      (isCurrentLocaleAu && (wasPreviousLocaleUs || wasPreviousLocaleCa)) ||
      (isCurrentLocaleUs && (wasPreviousLocaleCa || wasPreviousLocaleAu));

    if (localeChanged) {
      fetch(`/cart/clear.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Cart cleared:', data);
        })
        .catch((error) => {
          console.error('Error clearing cart:', error);
        });
    }
  };
  // Initial check on page load
  clearCartLocaleBased();

  window.addEventListener('popstate', () => {
    clearCartLocaleBased();
  });
});
